import {useListView} from '../../core/ListViewProvider'
import {EmployeeListSearchComponent} from './EmployeeListSearchComponent'
import {EmployeeListToolbar} from './EmployeeListToolbar'

const EmployeeListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      {/* <h5>Subscription List</h5> */}
      <EmployeeListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        <EmployeeListToolbar />
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {EmployeeListHeader}
